export default __webpack_public_path__ + "static/media/f500-valuation-graph1.440d582d.jpg";